import React from 'react';
import { useFormikContext } from 'formik';
import debounce from 'lodash/debounce';

export interface AutosaveProps {
  threshold?: number;
}

const FormikAutosave: React.FC<AutosaveProps> = ({ threshold = 0 }) => {
  const { submitForm, values, dirty } = useFormikContext();
  const isInitialMount = React.useRef(true);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSubmit = React.useCallback(debounce(submitForm, threshold), [
    threshold,
    submitForm,
  ]);

  React.useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    // Only autosave on a genuine user edit. With `enableReinitialize`, a
    // successful save feeds the server response back into `initialValues`;
    // Formik then resets `values` to match, which changes the `values`
    // reference and would otherwise retrigger this effect — firing a
    // second redundant submit (and a duplicate success snackbar). Gating
    // on `dirty` (values !== initialValues) skips that reset cycle.
    if (dirty) {
      debouncedSubmit();
    }
  }, [debouncedSubmit, values, dirty]);

  return null;
};

export default FormikAutosave;
